import { useTranslation } from 'react-i18next';

import { UserAvatar, IUserAvatarProps } from 'user/components/UserAvatar';

export const NavigationAvatar = (props: IUserAvatarProps) => {
    const [translate] = useTranslation();

    return (
        <UserAvatar aria-label={translate('profile')} size={32} {...props} />
    );
};
